import { Component, type ReactNode } from "react";

/**
 * Last line of defense: any render or effect throw below this point would
 * otherwise unmount the whole flow and leave the patient on a blank page.
 * React still reports the error (console and window error event).
 */
export default class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main role="alert" className="min-h-screen bg-[var(--color-leap21-bg)] px-6 py-16">
        <div className="max-w-xl mx-auto text-center space-y-6">
          <h1 className="text-[28px] font-extralight text-gray-900" style={{ letterSpacing: "-0.6px" }}>
            Something went wrong
          </h1>
          <p className="text-[15px] text-gray-600 leading-relaxed">
            Please reload the page to try again.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="w-full py-3 rounded-xl bg-gray-900 text-white text-[14px] font-medium hover:bg-gray-800 active:scale-[0.97] transition-[background-color,transform]"
          >
            Reload
          </button>
        </div>
      </main>
    );
  }
}
